import { IpDetectionBar, TerritorySwitch } from '@PegasusCore/pegasus-one-territory/src/script.js';

class IpBar extends IpDetectionBar {
    constructor() {
        super();
        this.matchingLocation = false; // Ensures matchingLocation is initialized
        this.currentTerritoryID = 0; // Default territory ID (prevents "undefined" error)
        this.show = false; // Ensures Alpine.js binding works correctly
    }

    getIPInfo() {
        let IPCookie;

        if (pegasus.getCookie('IP_VERIFIED') !== undefined) {
            IPCookie = pegasus.getCookie('IP_VERIFIED');
        }

        const data = new FormData();
        data.append('action', 'ip_detect_notify');
        data.append('url', window.location.href);

        fetch(ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            body: data
        }).then(async resp => {
            const data = await resp.json();
            console.log(data);

            if (data.current_view !== undefined) {
                this.currentTerritoryID = data.current_view; // Ensures Alpine receives correct data
            }

            if (typeof IPCookie !== 'undefined' && IPCookie !== '') {
                IPCookie = JSON.parse(IPCookie);
                if (parseInt(IPCookie.territory) === data.current_view) {
                    data.show_bar = false;
                }
                this.territory = parseInt(IPCookie.territory);
            }

            if (data.show_bar !== undefined) {
                this.matchingLocation = !data.show_bar;
                setTimeout(() => {
                    this.show = data.show_bar;
                }, 500);
            }

            return data;
        }).then(data => {
            if (typeof data.destination !== 'undefined' && data.destination !== '') {
                this.destination = data.destination;
            }

            if (!this.matchingLocation) {
                if (typeof IPCookie !== 'undefined' && IPCookie !== '') {
                    if (parseInt(IPCookie.territory) === parseInt(document.body.dataset.territory)) {
                        this.matchingLocation = true;
                        this.show = false;
                    }
                }
                const countrySelector = this.$root.querySelector('select');
                countrySelector.value = data.should_view_home;
                countrySelector.dispatchEvent(new Event('change'));
            }
        });
    }
}

// Initialize Alpine.js properly
document.addEventListener("alpine:init", () => {
    Alpine.data('ipDetectionBar', () => new IpBar());
});

// Ensure Switcher component is correctly initialized
class Switcher extends TerritorySwitch {
    constructor() {
        super();
        this.modalOpen = false;
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data('territorySwitch', () => new Switcher());
});
